'use client';
import { useEffect } from 'react';
import { rememberPageCity, registerPageUrlCity, notifySmartIntake } from '@/lib/smartIntakeStore';
// Every /<category>/<city> page remembers its city for the rest of the site — also pages with no experts / no questionnaire
// yet (bughunter #8 2026-09-28: /צבע/קריית-גת never saved קריית גת).
export default function RememberCity({ name, lat, lng }: { name: string; lat: number; lng: number }) {
  if (typeof window !== 'undefined') registerPageUrlCity(name); // during render: every reader on this page knows its URL city
  useEffect(() => { registerPageUrlCity(name); rememberPageCity(name, { lat, lng }); notifySmartIntake(); }, [name, lat, lng]);
  return null;
}
